const { find, intersection, cloneDeep } = require('@/plugins/lodash')

const mixin = {
  methods: {
    checkIsValidAddress(data) {
      data.is_valid = data.address && data.lat && data.lng && true
      return data.is_valid
    },
    getGoogleStaticMapUrl(lat, lng, size) {
      const mapSize = size || '640x210'
      let result =
        'https://maps.googleapis.com/maps/api/staticmap?zoom=16&size=' +
        mapSize +
        '&scale=2&key=' +
        process.env.VUE_APP_GOOGLE_MAP_API_KEY
      let pointMarkers = '&markers=size:mid|color:red|' + lat + ',' + lng
      result += pointMarkers
      return result
    },
    getShortAddress(addressComponents) {
      let result

      if (addressComponents && addressComponents.length > 0) {
        result = addressComponents[0] && addressComponents[0].short_name
        var foundLevel2 = find(addressComponents, function (item) {
          return (
            item.types &&
            (item.types[0] === 'administrative_area_level_2' || item.types[0] === 'political')
          )
        })

        if (foundLevel2) {
          return foundLevel2.short_name
        }

        var foundLevel1 = find(addressComponents, function (item) {
          return (
            item.types &&
            (item.types[0] === 'administrative_area_level_1' || item.types[0] === 'locality')
          )
        })

        if (foundLevel1) {
          return foundLevel1.short_name
        }
      }

      return result
    },
    checkWrongAddress(point) {
      const trustedTypes = ['premise', 'street_address']
      if (point.types) {
        const intersections = intersection(point.types, trustedTypes)
        point.can_be_wrong = !(intersections && intersections.length > 0)
      } else {
        delete point.can_be_wrong
      }
    },
    $_addressHelper_isValidAddress(data) {
      data.is_valid = data.address && data.lat && data.lng && true
      return data.is_valid
    },
    $_addressHelper_parseOrderPathQuery() {
      const pathQueryStr = this.$route.query.path
      if (!pathQueryStr) return

      const path = JSON.parse(pathQueryStr)
      let result = []
      path.forEach((p) => {
        this.checkIsValidAddress(p)
        result.push(p)
      })
      return result
    },
    $_addressHelper_savePickupLocationToCookie(data) {
      this.$cookie.set(this.$constants.COOKIE_NAME__PICKUP_LOCATION, JSON.stringify(data), {
        expires: this.$constants.COOKIE_EXPIRES_MAX_AGE__3M
      })
    },
    $_addressHelper_getPickupLocationFromCookie() {
      let data = this.$cookie && this.$cookie.get(this.$constants.COOKIE_NAME__PICKUP_LOCATION)
      return data && JSON.parse(data)
    },
    $_addressHelper_getGPSLocation() {
      if (this.$route.query && this.$route.query.lat && this.$route.query.lng) {
        return new Promise((resolve) => {
          resolve({
            coords: {
              latitude: Number.parseFloat(this.$route.query.lat),
              longitude: Number.parseFloat(this.$route.query.lng)
            }
          })
        })
      }

      return new Promise((resolve, reject) => {
        if (navigator.geolocation) {
          navigator.geolocation.getCurrentPosition(resolve, reject)
        } else {
          reject('Geolocation is not supported by this browser')
        }
      })
    },
    $_addressHelper_checkDuplicateOrder(params) {
      const api = global.$_VUE_APP_REST_API + this.$constants.API.rest_api.check_duplicate_order
      return this.axios({
        method: 'GET',
        url: api,
        headers: {
          'Content-Type': 'application/json'
        },
        json: true,
        params: params,
        timeout: 2000
      })
    },
    $addressHelper_updatePrediction(item) {
      item.address = item.address || item.description || item.formatted_address
      if (item.terms) {
        item.first_label = item.terms[0] && item.terms[0].value
        const start = item.terms[1] && item.terms[1].offset
        const length = item.address.length
        item.second_label = item.address.substring(start, length)
      } else if (item.address) {
        item.first_label = item.address.split(',')[0]
        const start = item.first_label.length
        const length = item.address.length
        item.second_label =
          item.address.substring(start, length).trim().replace(',', '') || item.short_address
      }

      if (!item.short_address && item.address_components && item.address_components.length > 0) {
        item.short_address = this.getShortAddress(item.address_components)
      }

      if (!item.short_address && item.address) {
        item.short_address = item.address.split(',')[0]
      }

      if (item.pelias) {
        item.too_far = (item.distance && item.distance > 15) || false
      }

      return cloneDeep(item)
    },
    $addressHelper_isValidNationwideAddress(data, index) {
      // data.is_valid = (data.address && data.lat && data.lng && true) || (data.ward_code && data.district_id && true)
      if (index === 0) {
        data.is_valid = data.address && data.lat && data.lng && true
      } else {
        data.is_valid = data.ward_code && data.district_id && true
      }

      return data.is_valid
    }
  }
}

export default mixin
